module.exports = __webpack_public_path__ + "static/media/login-banner.5d7d31f8.png";